// import React, { useState, useRef } from 'react';
import formatpainter from './image/formatpainter.png';
import removeformat from './image/removeformat.png';
import code from './image/code.png';
import * as EditorTypeAll from '../tinymce';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Formatpainter = ({ editorInstance }: Props) => {
  const formatpainterAction = (e: React.MouseEvent<HTMLDivElement>) => {
    document.body.click();
    editorInstance.execCommand('formatpainter');
    e.stopPropagation();
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={formatpainterAction}>
        <img width="18px" height="18px" src={formatpainter} />
      </div>
    </>
  );
};

export default Formatpainter;

export const Removeformat = ({ editorInstance }: Props) => {
  const removeformatAction = (e: React.MouseEvent<HTMLDivElement>) => {
    document.body.click();
    editorInstance.execCommand('removeformat');
    e.stopPropagation();
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={removeformatAction}>
        <img width="18px" height="18px" src={removeformat} />
      </div>
    </>
  );
};

export const Code = ({ editorInstance }: Props) => {
  const codeAction = (e: React.MouseEvent<HTMLDivElement>) => {
    document.body.click();
    editorInstance.execCommand('opencode');
    e.stopPropagation();
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={codeAction}>
        <img width="18px" height="18px" src={code} />
      </div>
    </>
  );
};
